'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Edit03IconSolid } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
interface ThesesEmptyProps {
  isOwn: boolean;
  /** Omit the outer `<Panel>` when nested inside another framed surface. */
  unframed?: boolean;
}
export function ThesesEmpty(t0) {
  const $ = _c(12);
  const {
    isOwn,
    unframed: t1
  } = t0;
  const unframed = t1 === undefined ? false : t1;
  const t = useTranslations("profile.next.empty.theses");
  const t2 = !unframed;
  let t3;
  if ($[0] !== t) {
    t3 = t("title");
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("body");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isOwn || $[5] !== t) {
    t5 = isOwn ? <AnimatedButton asChild={true} variant="secondary"><Link href="/markets">{t("cta")}</Link></AnimatedButton> : undefined;
    $[4] = isOwn;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <EmptyState framed={t2} icon={Edit03IconSolid} title={t3} description={t4} action={t5} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}